function getHttpsUrl(url: string): string {
  const split = url?.split("://");
  if (split?.at(0) === "http") {
    return `https://${split.at(-1)}`;
  }
  return url;
}

export default getHttpsUrl;
